
export const widgetSrcChartList :{ [key: string]: string } ={
    'advanced_real_time_chart': 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js',

  // Add more sources as needed
};